/**
 * ## Chart Controller
 *
 * @module src/localization
 */

"use strict";

const Localize = require("localize");
const cloneDeep = require("clone-deep");
const translations = require("./translations.json");
const conf = require("../../config");
const func = require("../../controllers/func");
let localization = null;

let language = "en";
if (func.getQueryVar("language")) {
  language = func.getQueryVar("language");
} else if (
  typeof window !== "undefined" &&
  window.localStorage.getItem("language")
) {
  language = window.localStorage.getItem("language");
}
conf.vars.language = language;

const translate = (phrase) => {
  if (phrase !== null && phrase && localization) {
    return localization.translate(phrase);
  }
  return "";
};

const treplace = (word, phrase) => {
  if (phrase !== null && phrase && word) {
    return phrase.replace(word, localization.translate(word));
  }
  return "";
};

const tarray = (word, arr) => {
  if (arr && word) {
    const thisArray = cloneDeep(arr);
    for (let i = 0; i < thisArray.length; ++i) {
      thisArray[i].description = treplace(word, thisArray[i].description);
    }
    return thisArray;
  }
  return [];
};

const toptions = (arr) => {
  const thisarray = cloneDeep(arr);
  for (let i = 0; i < thisarray.length; ++i) {
    thisarray[i].description = translate(thisarray[i].description);
  }
  return thisarray;
};

const tcal = (str) => {
  let newstr = str;
  for (let i = 0; i < conf.vars.month.length; ++i) {
    newstr = newstr.replace(conf.vars.month[i], translate(conf.vars.month[i]));
  }
  for (let i = 0; i < conf.vars.dayfull.length; ++i) {
    newstr = newstr.replace(
      conf.vars.dayfull[i],
      translate(conf.vars.dayfull[i])
    );
  }
  return newstr;
};

const tpeople = (arr) => {
  const thisarray = cloneDeep(arr);
  for (let i = 0; i < thisarray.length; ++i) {
    thisarray[i].description = thisarray[i].description.replace(
      "people",
      localization.translate("people")
    );
    thisarray[i].description = thisarray[i].description.replace(
      "person",
      localization.translate("person")
    );
  }
  return thisarray;
};

const initServer = (lang) => {
  localization = new Localize(translations);
  localization.setLocale(lang);
};

/** init
 */
const init = () => {
  localization = new Localize(translations);

  localization.setLocale(language);

  if (language !== "en") {
    $(".tab_wide_label").css("font-size", "12px");
    $(".tab_wide_label").css("margin-top", "0px");
    $(".tab_wide_label").css("line-height", "11px");
    $(".waitlist_tabs_top").css("font-size", "12px");
    $(".stats_tabs_top").css("font-size", "12px");
    $(".reservation_tabs_top").css("font-size", "12px");
  }

  conf.init();

  conf.vars.quoteTimes = tarray("minute", conf.vars.quoteTimes);
  conf.vars.quoteTimes = tarray("hour", conf.vars.quoteTimes);

  $("#l1").text(localization.translate("Configuration"));
  $("#l2").text(localization.translate("Editor Mode"));
  $("#login_submit").text(localization.translate("Login"));
  $("#login_username").attr("placeholder", localization.translate("Username"));
  $("#login_password").attr("placeholder", localization.translate("Password"));
  $("#modal_addparty_preselect").attr(
    "placeholder",
    localization.translate("Touch to select tables")
  );
  $("#modal_addparty_customNotes").attr(
    "placeholder",
    localization.translate("Custom notes")
  );
  $("#search_box").attr("placeholder", localization.translate("Find..."));
  $("#list_view").text(localization.translate("List View"));
  $("#editor_mode_tables").text(localization.translate("Move Tables"));
  $("#editor_mode_chart").text(localization.translate("Move Chart"));
  $("#layout_chart_editor_save").text(localization.translate("Save Map"));
  $("#l3").text(
    localization.translate(
      "Select a color or option above, then tap tables to assign " +
        "them to a section. Select the button below and tap a table to clear section assignments " +
        "or just reassign them."
    )
  );
  $("#layout_chart_section_save").text(localization.translate("Save Template"));
  $("#chart_section_unassign").text(localization.translate("Unassign Table"));
  $("#layout_chart_section_save").text(localization.translate("Save Template"));
  $("#layout_chart_header_4top_desc").text(
    localization.translate("4-Top Turn Time:")
  );
  $("#l4").text(localization.translate("Waiting"));
  $("#l5").text(localization.translate("Reservations"));
  $("#l6").text(localization.translate("Direct Seating"));
  $("#l7").text(localization.translate("Filter"));
  $("#l8").text(localization.translate("Sections"));
  $("#l9").text(localization.translate("Seated"));
  $("#l10").text(localization.translate("No Shows"));
  $("#l11").text(localization.translate("Notes"));
  $("#tab_btn_addparty").text(localization.translate("Add To Waitlist"));
  $("#tab_btn_addparty_wide").text(localization.translate("Add To Waitlist"));
  $("#tab_btn_addreservation").text(localization.translate("Add Reservation"));
  $("#tab_btn_addreservation_wide").text(
    localization.translate("Add Reservation")
  );
  $("#l12").text(localization.translate("Stats"));
  $("#l13").text(localization.translate("Waiting"));
  $("#14").text(localization.translate("Reservations"));
  $("#waitlist_tabs_top1").text(localization.translate("Next"));
  $("#waitlist_tabs_top2").text(localization.translate("Longest"));
  $("#waitlist_tabs_top3").text(localization.translate("Next"));
  $("#waitlist_tabs_top4").text(localization.translate("Longest"));
  $("#reservation_tabs_top1").text(localization.translate("Today"));
  $("#reservation_tabs_top2").text(localization.translate("Tomorrow"));
  $("#reservation_tabs_top3").text(localization.translate("Today"));
  $("#reservation_tabs_top4").text(localization.translate("Tomorrow"));
  $("#tab_btn_direct").text(localization.translate("Direct Seating"));
  $("#tab_btn_filter").text(localization.translate("Filter By Status"));
  $("#tab_btn_sections").text(localization.translate("Sections & Servers"));
  $("#tab_btn_seated").text(localization.translate("Seated Parties"));
  $("#tab_btn_noshows").text(localization.translate("No Shows"));
  $("#tab_btn_notes").text(localization.translate("Notes"));
  $("#tab_btn_stats").text(localization.translate("Statistics"));
  $("#tab_btn_precheck").text(localization.translate("Pre-Check"));
  $("#l15").text(localization.translate("Current Reservation Limit Rule Set"));
  $("#l17").text(localization.translate("Rule set type"));
  $("#l18").text(localization.translate("Start date for this rule set"));
  $("#l19").text(localization.translate("Through date"));
  $("#l20").text(localization.translate("Apply rules to selected days:"));
  $("#l21").text(localization.translate("Monday"));
  $("#l22").text(localization.translate("Tuesday"));
  $("#l23").text(localization.translate("Wednesday"));
  $("#l24").text(localization.translate("Thursday"));
  $("#l25").text(localization.translate("Friday"));
  $("#l26").text(localization.translate("Saturday"));
  $("#l27").text(localization.translate("Sunday"));
  $("#l28").text(localization.translate("Start accepting reservations at"));
  $("#l29").text(localization.translate("Stop accepting reservations at"));
  $("#modal_addparty_h1").text(localization.translate("Add Party"));
  $("#modal_tabs_btn1").text(localization.translate("Wait List"));
  $("#modal_tabs_btn2").text(localization.translate("Reservations"));
  $("#l30").text(localization.translate("Name"));
  $("#l31").text(localization.translate("Party"));
  $("#l32").text(localization.translate("Quoted Time (estimated)"));
  $("#l33").text(localization.translate("Date:"));
  $("#l34").text(localization.translate("Time:"));
  $("#l35").text(localization.translate("Alert By"));
  $("#modal_addparty_label_cell").text(
    localization.translate("Cell Phone Number")
  );
  $("#modal_addparty_label_pager").text(
    localization.translate("Coaster Pager Number")
  );
  $("#modal_addparty_label_email").text(
    localization.translate("Email Address")
  );
  $("#modal_addparty_label_created_by").text(
    localization.translate("Created By")
  );
  $("#modal_tabs_side_btn1").text(localization.translate("Basic Info"));
  $("#modal_tabs_side_btn2").text(localization.translate("Needs"));
  $("#modal_tabs_side_btn3").text(localization.translate("Basic Info"));
  $("#modal_tabs_side_btn4").text(localization.translate("Needs"));
  $("#l37").text(localization.translate("Seating Location"));
  $("#l38").text(localization.translate("Guest called ahead"));
  $("#l39").text(localization.translate("Preselect tables"));
  $("#l40").text(localization.translate("Additional Notes"));
  $("#modal_addparty_btn1").text(localization.translate("Cancel"));
  $("#modal_addparty_btn2").text(localization.translate("Add Party"));
  $("#modal_addparty_h1").text(localization.translate("Add Party"));
  $("#titlebar_standard_direct").text(localization.translate("Direct Seating"));
  $("#l85").text(localization.translate("Pre-Check"));
  $("#l41").text(localization.translate("Next Section"));
  $("#l42").text(localization.translate("Party Size"));
  $("#directseat_head_title_id").text(localization.translate("Suggested"));
  $("#l50").text(localization.translate("Reservation Search"));
  $("#l51").text(localization.translate("Instructional Guide"));
  $("#l52").text(
    localization.translate("Touch a date to show it's reservations")
  );
  $("#l53").text(
    localization.translate(
      "Touch the same date again to show daily availability"
    )
  );
  $("#l54").text(
    localization.translate("Touch a time to make a reservation at that time")
  );
  $("#l55").text(
    localization.translate(
      "Searching by name or notes will search all future " + "reservations"
    )
  );
  $("#l56").text(
    localization.translate(
      "If on a smaller screen, scroll down for reservations " + "after search"
    )
  );
  $("#l57").text(localization.translate("Search By Name"));
  $("#l58").text(localization.translate("Search By Custom Notes"));
  $("#l61").text(localization.translate("Add a New Note"));
  $("#l62").text(localization.translate("Filter"));
  $("#l62b").text(localization.translate("View Mode"));
  $("#l63").text(localization.translate("Search By Name"));
  $("#reservation_search_name_btn").text(localization.translate("Search"));
  $("#reservation_search_custom_btn").text(localization.translate("Search"));
  $("#stats_tabs_top1").text(localization.translate("Last Hour"));
  $("#stats_tabs_top2").text(localization.translate("Today"));
  $("#stats_tabs_top3").text(localization.translate("Last Hour"));
  $("#stats_tabs_top4").text(localization.translate("Today"));
  $("#note_delete").text(localization.translate("Delete"));
  $("#login_forget").text(localization.translate("Forget your password?"));
  $("#manager_dashboard").text(localization.translate("Manager Dashboard"));
  $("#disconnect_main").text(localization.translate("Offline"));
  $("#l101").text(localization.translate("So Far Today:"));
  $("#l102").text(localization.translate("parties"));
  $("#l103").text(localization.translate("covers"));
  $("#l10b").text(localization.translate("Res No Shows"));
  $("#btn_waiting_partysize").text(localization.translate("By Party Size"));
  $("#btn_waiting_waittime").text(localization.translate("By Wait Time"));
  $("#btn_reservation_quick").text(
    localization.translate("Quick View & Create")
  );
  $("#btn_reservation_detailed").text(
    localization.translate("Detailed View By Date")
  );
  $("#l62d").text(localization.translate("Search"));
  $("#l62g").text(localization.translate("Select A Date"));
  $("#l62h").text(localization.translate("Options"));
  $("#reservation_box_export_csv").text(localization.translate("Export CSV"));
  $("#reservation_box_export_print").text(localization.translate("Print"));
  $("#tab_btn_resnoshows").text(localization.translate("Res No Shows"));
  $("#l34b").text(localization.translate("Override"));
  $("#layout_alt_tables_move").text(localization.translate("Move Tables"));
  $("#layout_alt_tables_chart").text(localization.translate("Move Chart"));
  $("#layout_alt_tables_reset").text(localization.translate("Reset"));
  $("#layout_alt_tables_done").text(localization.translate("Done"));
  $("#layout_alt_tables_resetsave").text(
    localization.translate("Reset Table Positions")
  );
  $("#reportliststat").text(localization.translate("Stats Grid"));
  $("#loyalty_text").text(localization.translate("Add customer to Email List"));
};

const setLanguage = (lang) => {
  language = lang;
  conf.vars.language = lang;
  init();
};

module.exports = {
  init,
  initServer,
  translate,
  treplace,
  tarray,
  toptions,
  tcal,
  tpeople,
  setLanguage,
};



/** WEBPACK FOOTER **
 ** ./src/common/localization/index.js
 **/